// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22QIA","question":"styles_question__1uLyz","description":"styles_description__1FfuD"};